import { privateAPI } from 'services/private';

const patchTransactionsDraft = (draft, transaction) => {
  if (!Array.isArray(draft?.data?.data)) {
    return false;
  }

  const items = draft.data.data;
  const existingIndex = items.findIndex(item => Number(item.id) === Number(transaction.id));

  if (existingIndex >= 0) {
    items.splice(existingIndex, 1);
  }

  items.unshift(transaction);

  return true;
};

export default function upsertTransactionListItem(dispatch, transaction, queryArgs = { page: 1, search: '' }) {
  if (!transaction?.id) {
    return false;
  }

  let patched = false;

  try {
    dispatch(
      privateAPI.util.updateQueryData('listTransaction', queryArgs, draft => {
        if (patchTransactionsDraft(draft, transaction)) {
          patched = true;
        }
      })
    );
  } catch {
    // Cache entry may not exist yet.
  }

  return patched;
}
